import { useMutation, useQueryClient } from "react-query";

import client from "../../Client";

type PriceUpdatePayload = {
    internal_product_id?: string;
    half?: number;
    one?: number;
    two_five?: number;
    five?: number;
    joint?: number;
    piece?: number;
    shop_group_id: string;
    edible?: any[];
    pre_rolled_joints?: any[];
    cannabis?: any[];
};

export const useUpdatePriceMutation = () => {
    const queryClient = useQueryClient();

    return useMutation(
        ({ priceId, data }: { priceId: string; data: PriceUpdatePayload }) =>
            client.put(`/v1/prices/${priceId}`, data).then((res) => res.data),
        {
            onSuccess: (_, { priceId }) => {
                queryClient.invalidateQueries(["price", priceId]);
                queryClient.invalidateQueries(["prices"]);
            },
        }
    );
};
